import { useTranslation } from 'react-i18next';

import QuestionTypeIcon from '@/components/question/QuestionTypeIcon';
import { QuestionTypeEnum } from '@/models/Question';
import { twMerge } from 'tailwind-merge';

type QuestionPlaceholderProps = {
  type: QuestionTypeEnum;
  className?: string;
};

export default function QuestionPlaceholder({
  type,
  className,
}: QuestionPlaceholderProps) {
  const { t } = useTranslation('translation', {
    keyPrefix: 'questionTypes',
  });

  return (
    <div
      className={twMerge(
        'flex flex-col items-center justify-center gap-4 rounded-xl border border-dashed border-base-300 bg-base-200/50 p-12',
        className,
      )}
    >
      <QuestionTypeIcon
        type={type}
        className="h-12 w-12 text-base-content/40"
      />
      <span className="text-sm text-base-content/60">{t(type)}</span>
    </div>
  );
}
